import React from "react";
import { Phone, Clock } from "lucide-react";
import { contact } from "../mock";

const ContactCTA = () => {
  return (
    <section id="contact" className="relative bg-[#0e0e10] py-20">
      <div className="max-w-7xl mx-auto px-6">
        <div className="relative rounded-3xl overflow-hidden bg-gradient-to-br from-[#f15a24] to-[#e04a16] px-8 py-16 sm:px-16 text-center">
          {/* Decorative swirls */}
          <div className="absolute -top-20 -left-16 w-72 h-72 bg-white/10 rounded-full blur-2xl" />
          <div className="absolute -bottom-24 -right-10 w-80 h-80 bg-black/10 rounded-full blur-2xl" />

          <div className="relative">
            <span className="inline-block text-xs sm:text-sm font-semibold tracking-[0.2em] uppercase text-white bg-black/25 px-5 py-2 rounded-full">
              Universal connectors with superior performance
            </span>

            <a
              href={`tel:${contact.phone.replace(/[^0-9+]/g, "")}`}
              className="mt-8 flex items-center justify-center gap-4 text-white font-display font-semibold text-3xl sm:text-5xl tracking-tight hover:opacity-90 transition-opacity"
            >
              <Phone size={40} className="hidden sm:block" strokeWidth={2.2} />
              {contact.phone}
            </a>

            <div className="mt-6 inline-flex items-center gap-2 text-white/90 text-sm font-medium">
              <Clock size={16} />
              We are available {contact.hours}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactCTA;
